import { useEffect, useMemo, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

import { CustomerModel } from '../../../domain/models'
import { fetchCustomer } from '../../../main/usecases'

import { maskCpf } from '../../utils'
import { useOnChangeDetect } from '../../contexts'
import { SubHeader, RegistrationDataForms } from '../../components'

import * as S from './styles'

const RegistrationData = ({ match }: any) => {
  const [customer, setCustomer] = useState<CustomerModel>()
  const location = useLocation()
  const { refresh } = useOnChangeDetect()

  const activeRouteDataRegistration = useMemo(() => {
    if (
      window.location.pathname ===
      `/meus-pacientes/${match?.params?.id}/dados-cadastrais`
    ) {
      return true
    }
    return false
  }, [match?.params?.id])

  const activeRouteService = useMemo(() => {
    if (
      window.location.pathname ===
      `/meus-pacientes/${match?.params?.id}/prontuario`
    ) {
      return true
    }
    return false
  }, [match?.params?.id])

  useEffect(() => {
    ;(async () => {
      try {
        if (match.params.id) {
          const data = await fetchCustomer({
            id: match?.params?.id
          }).load()
          setCustomer(data)
        }
      } catch (error) {
        console.error(error)
      }
    })()
  }, [match.params.id, refresh])

  return (
    <S.Wrapper>
      {customer && (
        <SubHeader name={customer.nome} cpf={maskCpf(customer.cpf)} />
      )}
      <S.CardContainer>
        {customer && (
          <S.HeaderContainer>
            <S.LinksContainer>
              <Link
                to={`/meus-pacientes/${match?.params?.id}/dados-cadastrais`}
                className={activeRouteDataRegistration ? 'active' : ''}
              >
                Dados Cadastrais
              </Link>
              <Link
                to={`/meus-pacientes/${match?.params?.id}/prontuario`}
                className={activeRouteService ? 'active' : ''}
              >
                Prontuário
              </Link>
            </S.LinksContainer>
          </S.HeaderContainer>
        )}
        <RegistrationDataForms
          customer={customer}
          stateValues={location.state}
        />
      </S.CardContainer>
    </S.Wrapper>
  )
}
export default RegistrationData
